import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalOptions } from './models/modal-options.model';
import { ModalService } from './modal.service';
import { GenericsHelperMethods } from './generics-helper-methods';
import { SpanLinkModal } from './span-link-modal.component';

export abstract class SpanLinkModalBase {
    public modalContent: string;
    public modalTitle: string;
    public backdropCssClass: string;
    public showCancel: boolean;
    public acceptText: string;
    public cancelText: string;

    constructor(protected modalService: ModalService) { };

    public getModalOptions(): ModalOptions {
        // create modal options.
        let options = new ModalOptions();
        options.content = this.modalContent;
        options.title = this.modalTitle ? this.modalTitle : 'Information';
        options.backdropCssClass = this.backdropCssClass;
        options.showCancel = this.showCancel;
        options.acceptText = this.acceptText ? this.acceptText : options.acceptText;
        options.cancelText = this.cancelText ? this.cancelText : options.cancelText;

        this.setCustomOptions(options);

        return options;
    }

    // Allows child class to set custom options
    public setCustomOptions(options: ModalOptions): void {
    }

    public show(): void {
        // options are built in a separate method so the method can be overridden by derived types.
        let options: ModalOptions = this.getModalOptions();

        // use the modal service to create the modal and backdrop dynamically.
        this.modalService.showModal(SpanLinkModal, options);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/span-link-modal-base.ts